import { Inject, Injectable, Renderer2, RendererFactory2, RendererStyleFlags2 } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { TranslocoService } from '@ngneat/transloco';

import { ErrorSnackbarComponent } from '../components/snackbar/error-snackbar/error-snackbar.component';
import { InfoSnackbarComponent } from '../components/snackbar/info-snackbar/info-snackbar.component';
import { SuccessSnackbarComponent } from '../components/snackbar/success-snackbar/success-snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  private renderer: Renderer2;
  constructor(
    private snackBar: MatSnackBar,
    rendererFactory: RendererFactory2
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }
  config: MatSnackBarConfig<any> = {
    duration: 10000,
    data: {},
    panelClass: ['snackbar'],
    horizontalPosition: 'right',
    verticalPosition: 'bottom',
  };
  openSnackbar(snackbarType: SnackbarType, config?: MatSnackBarConfig<SnackbarData>, positionClass?: SnackbarPositionClass) {
    switch (snackbarType) {
      case SnackbarType.Success: {
        this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          ...this.config,
          panelClass: ['snackbar', 'success-snackbar'],
          ...config,
        });
        break;
      }
      case SnackbarType.Information: {
        this.snackBar.openFromComponent(InfoSnackbarComponent, {
          ...this.config,
          panelClass: ['snackbar', 'info-snackbar'],
          ...config,
        });
        break;
      }
      case SnackbarType.Error: {
        this.snackBar.openFromComponent(ErrorSnackbarComponent, {
          ...this.config,
          panelClass: ['snackbar', 'error-snackbar'],
          ...config,
        });
        break;
      }
    }
  }
}

export interface SnackbarData {
  msg: string;
  translate: boolean;
  withoutIcon?: boolean;
}

export type SnackbarPositionClass = 'snackbar-bottom';
export enum SnackbarType {
  Success = 'success',
  Information = 'information',
  Error = 'Error',
}
